import React from 'react';

const HeroSection = () => {
  return (
    <section id="home" className="hero-section">
      {/* Background Hexagons */}
      <div className="hero-bg-shapes">
        <div className="hex-shape shape-1"></div>
        <div className="hex-shape shape-2"></div>
      </div>

      <div className="container hero-container">
        {/* Left Content */}
        <div className="hero-content">
          <div className="eyebrow">
            <span className="sparkle">✨</span> DIGITAL MARKETING AGENCY
          </div>

          <h1 className="hero-title">
            Buzz Smart.<br />
            <span className="text-gradient-teal-gold">Grow Faster.</span>
          </h1>

          <p className="hero-description">
            Tailored solutions that drive real results. We build amazing digital experiences that help your business scale faster.
          </p>

          <div className="hero-buttons">
            <a href="#cta"><button className="btn-primary">Start Your Project Now</button></a>
            <a href="#portfolio"><button className="btn-secondary">View Our Portfolio</button></a>
          </div>

          <div className="hero-core-values" style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
            <div className="value-pill" style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', padding: '10px 20px', borderRadius: '30px', color: '#fff', fontSize: '0.9rem', display: 'flex', alignItems: 'center', gap: '8px', backdropFilter: 'blur(10px)' }}>
              <span>🎯</span> Data-Driven Strategy
            </div>
            <div className="value-pill" style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', padding: '10px 20px', borderRadius: '30px', color: '#fff', fontSize: '0.9rem', display: 'flex', alignItems: 'center', gap: '8px', backdropFilter: 'blur(10px)' }}>
              <span>💡</span> Creative Innovation
            </div>
          </div>
        </div>

        {/* Right Graphic */}
        <div className="hero-graphic">
          <div className="dashboard-mockup" style={{ padding: '32px' }}>
            <div className="dashboard-header" style={{ padding: '0 0 16px 0', marginBottom: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid rgba(255, 255, 255, 0.05)' }}>
              <div style={{ fontSize: '18px', fontWeight: '700', color: '#fff' }}>Omnichannel Ecosystem</div>
              <div style={{ display: 'flex', gap: '6px' }}>
                <div className="dot red"></div>
                <div className="dot yellow"></div>
                <div className="dot green"></div>
              </div>
            </div>
            
            <div className="process-workflow" style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              {/* Platform 1 */}
              <div className="process-step" style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
                <div style={{ width: '40px', height: '40px', borderRadius: '10px', background: 'rgba(66, 133, 244, 0.1)', color: '#4285F4', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '20px', flexShrink: 0 }}>G</div>
                <div>
                  <div style={{ color: '#fff', fontWeight: '600', marginBottom: '4px' }}>Google Network</div>
                  <div style={{ color: 'var(--text-muted)', fontSize: '13px', lineHeight: '1.4' }}>Search, Display, and Performance Max integration.</div>
                </div>
              </div>
              
              {/* Platform 2 */}
              <div className="process-step" style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
                <div style={{ width: '40px', height: '40px', borderRadius: '10px', background: 'rgba(255, 105, 180, 0.1)', color: '#ff69b4', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '20px', flexShrink: 0 }}>∞</div>
                <div>
                  <div style={{ color: '#fff', fontWeight: '600', marginBottom: '4px' }}>Meta Ecosystem</div>
                  <div style={{ color: 'var(--text-muted)', fontSize: '13px', lineHeight: '1.4' }}>Advanced audience targeting on Facebook & Instagram.</div>
                </div>
              </div>

              {/* Platform 3 */}
              <div className="process-step" style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
                <div style={{ width: '40px', height: '40px', borderRadius: '10px', background: 'rgba(255, 255, 255, 0.05)', color: '#fff', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '20px', flexShrink: 0 }}>🔗</div>
                <div>
                  <div style={{ color: '#fff', fontWeight: '600', marginBottom: '4px' }}>SEO & Content</div>
                  <div style={{ color: 'var(--text-muted)', fontSize: '13px', lineHeight: '1.4' }}>Organic growth and high-authority link building.</div>
                </div>
              </div>
            </div>

            <div className="floating-card" style={{ bottom: '-20px', left: '-30px', padding: '12px 20px' }}>
              <div className="icon-up" style={{ fontSize: '16px', width: '32px', height: '32px', background: 'rgba(255,255,255,0.05)', color: '#fff' }}>🌐</div>
              <div>
                <div className="card-title">Seamless Integration</div>
                <div className="card-value" style={{ fontSize: '14px' }}>Data synced across channels</div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </section>
  );
};

export default HeroSection;
